import { CircularProgress, Box, styled } from '@mui/material';
import equip from './Asset/images/equip.png';

const StyledLoading = styled('div')({
  width: '100%',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '& img': {
    width: 'auto',
    height: '25px'
  },
  '& .circleProgress': {
    position: 'absolute',
    left: -7,
    right: 0,
    top: 'calc(50% - 20px)'
  }
});

const Loading = () => {
  return (
    <StyledLoading>
      <Box position="relative">
        {/* <img src="/assets/images/logo-circle.svg" alt="" /> */}
        <img src={equip} alt="e-Quip" />
        <CircularProgress className="circleProgress" />
      </Box>
    </StyledLoading>
  );
};

export default Loading;
